export default {"src":"/_next/static/media/letter.36d83b8f.svg","height":45,"width":65};